
















































import { OrderContext } from '@spa/components/pages/order/model/context/order-context'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'
import { ContactService } from '@spa/services/api/contact'

import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import ContactForm from '@spa/components/organisms/contact/ContactForm.vue'
import { AddressFormState } from '@spa/components/organisms/profile/addressFormState'
import { NameFormState } from '@spa/components/organisms/profile/nameFormState'
import {
  AddressFieldsEnabledState,
  interaction,
  UpdateContactErrorType,
} from '@spa/components/pages/mypage/edit/contact/interaction'

import * as CurrentTime from '@/models/current-time/functions'
import { EventBusForThirdParty } from '@/usecases/event-bus-for-third-party/event-bus'
import { User } from '@spa/store/modules/user/types'

@Component({
  components: {
    SpaErrorDialog,
    ContactForm,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class Contact extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ required: true })
  context: OrderContext

  status: Status = Status.Pending

  contactId: string = ''

  nameForm: NameFormState = {
    firstName: '',
    lastName: '',
  }

  addressForm: AddressFormState = {
    zipcode: '',
    prefectureCode: '',
    city: '',
    town: '',
  }

  addressFieldsEnabledState: AddressFieldsEnabledState =
    AddressFieldsEnabledState.init({})

  tel: string = ''

  showModal: boolean = false

  modalMessage: string = ''

  contactService = new ContactService()

  get user(): User {
    return this.$store.state.user.user
  }

  get cancelUrl(): string {
    return this.context.path.editContact
  }

  get isLoading() {
    return this.status === Status.Loading
  }

  async created() {
    this.status = Status.Loading
    this.contactId = this.$route.params.id

    const initializeContactForm = interaction.initializeContactForm({
      contactService: this.contactService,
    })

    const [result] = await Promise.all([
      initializeContactForm({ contactId: this.contactId }),
      this.$store.dispatch('user/get'),
    ])

    result.fold(
      this.handleInitializeError,
      async (formState) => {
        this.nameForm = formState.nameForm
        this.addressForm = formState.addressForm
        this.tel = formState.tel
        this.addressFieldsEnabledState =
          AddressFieldsEnabledState.init(this.addressForm)

        this.status = Status.Completed

        EventBusForThirdParty.getInstance().publish('page-initialized', {
          url: window.location.href,
          initializedAt: CurrentTime.create().now,
          user: this.user,
        })
      }
    )
  }

  handleInitializeError() {
    this.status = Status.Failed
    this.modalMessage = 'お届け先情報の取得に失敗しました'
    this.showModal = true
  }

  enableAddressFields() {
    this.addressFieldsEnabledState =
      this.addressFieldsEnabledState.searchedAddress()
  }

  async validateAll(): Promise<boolean> {
    return this.$validator.validateAll()
  }

  async submit() {
    this.registerEditedAddress()
  }

  async registerEditedAddress(): Promise<void> {
    this.status = Status.Loading

    const updateContact = interaction.updateContact({
      contactService: this.contactService,
      invalidInputValidator: this.validateAll,
    })

    const result = await updateContact({
      contactId: this.contactId,
      contactFormState: {
        nameForm: this.nameForm,
        addressForm: this.addressForm,
        tel: this.tel,
      },
    })

    result.fold<void>(
      this.handleSubmissionError,
      async () => {
        await this.$store.dispatch('contact/load', { force: true })

        this.$router.push(this.context.path.editContact)
      }
    )
  }

  handleSubmissionError(errorType: UpdateContactErrorType) {
    switch (errorType) {
      case 'invalid-input':
        this.status = Status.Pending
        this.modalMessage = '入力内容が正しくありません'
        this.showModal = true
        break
      default:
        this.status = Status.Failed
        this.modalMessage = '配送先が登録できませんでした。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
        this.showModal = true
    }
  }
}
